import React from "react"
import {routeConstants} from "../../constants/RouteConstants";
import {apiConstants} from "../../constants/ApiConstants";
import {StateFilterOption, TaskStatus} from "../../widgets/TaskStatus";
import {headerSortingClasses, sortCaret} from "../../widgets/TableSortingHelpers";
import dateFormat from "dateformat";
import {ActionButtons} from "../../widgets/ActionButtons";
import FilteredTable from "../../components/containers/FilteredTable";

export function EatTasks() {

  let filterView = (state, activeState, handler) => {
    return (<StateFilterOption state={state} active={activeState === state.State} onClick={handler} />)
  }
  const columns = [
    {
      dataField: "SettingsID",
      text: "Аккаунт",
      headerClasses: "text-nowrap",
    },
    {
      dataField: "EndTime",
      text: "Окончание",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      classes: "text-nowrap",
      headerClasses: "text-nowrap",
      formatter: function (cell, row) {
        return dateFormat(row.EndTime, "HH:MM dd.mm.yy");
      },
    },
    {
      dataField: "Name",
      text: "Название",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      formatter: function (cell, row) {
        return (<a href={row.Link} target="_blank">{row.Name}</a>);
      },
    },
    {
      dataField: "StartPrice",
      text: "Старт.цена",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      headerClasses: "text-nowrap",
    },
    {
      dataField: "SecondPrice",
      text: "Стоп.цена",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      headerClasses: "text-nowrap",
    },
    {
      dataField: "FirstPrice",
      text: "Закупка",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      headerClasses: "text-nowrap",
    },
    {
      dataField: "LastPrice",
      text: "Посл.цена",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      headerClasses: "text-nowrap",
    },
    {
      dataField: "user",
      text: "Создал",
      sort: false
    },
    {
      dataField: "Status",
      text: "Статус",
      sort: false
    },
    {
      dataField: "State",
      text: "Статус",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      formatter: function (cell, row) {
        return (<TaskStatus status={row.State}/>);
      },
    },
    {
      dataField: "id",
      text: "Действия",
      formatter: function (cell, row) {
        return (<ActionButtons prefix='eat' status={row.State} id={row.id} />)
      },
      classes: "text-right pr-0",
      headerClasses: "text-right pr-3",
      style: {
        minWidth: "100px",
      },
    }
  ];

  return (
    <>
      <FilteredTable
        sortField={"EndTime"}
        dataUrl={apiConstants.API_URL + '/eattasks'}
        filterView={filterView}
        columns={columns}
        title={"Задачи на Березке"}
        addLink={routeConstants.EAT_TASK_ADD}
      />
    </>
  );
}


